import React from "react";

class MessageForPGUsers extends React.Component {
    // constructor(props) {
    //     super(props);

    //     // this.handleLoad = this.handleLoad.bind(this)
    // }

    render() {
        //let warningIcon;
        if(this.props.pgEmployee)
        {
            return (
                <div className='warning-pg'>
                    You have been identified as a PG user if you want to request for SharePoint Sites please contact with your PG IT Collaboration team or create required resource directly in PG provisioning tool: <a href="https://hitachipowergrids.sharepoint.com/SitePages/SharePointSites.aspx">https://hitachipowergrids.sharepoint.com/SitePages/SharePointSites.aspx</a><br/>
                </div>
            );
        }
        else
        {
            return "";
        }
    }
}
export default MessageForPGUsers



// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/MessageForPGUsers.js